<!-- .block-banner -->
<div class="block block-banner" style="padding-top: 50px;">
    <div class="container">
        <a [routerLink]="['/shop/audio']" class="block-banner__body">
            <div class="block-banner__image block-banner__image--desktop" style="background-image: url('assets/images/banners/banner-21.jpg')"></div>
            <div class="block-banner__image block-banner__image--mobile" style="background-image: url('assets/images/banners/banner-2-mobile.jpg')"></div>
        </a>
    </div>
</div>
<!-- .block-banner / end -->
